import { TranslationKey, useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityExport } from '../../projectDetailsActivities.models';

export const ExportActivity = ({ values }: IProjectActivity<IProjectActivityExport>): ReactElement => {
  const { t } = useTranslator();

  const getText = (): TranslationKey => {
    if (values.configurationVersion) {
      if (values.setVersion) {
        return 'activity_description_Export_01';
      }
      return 'activity_description_Export_01_no_set';
    }
    return 'activity_description_Export_01_legacy';
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { isExportReady, isGeneratedDuringImport, ...rest } = values;

  return (
    <span>
      {values.isGeneratedDuringImport ? (
        <>
          {t('activity_description_Export_during_import', { ...rest })}
          {values.isExportReady ? t('activity_description_Export_annotated_accepted', { ...rest }) : ''}
        </>
      ) : (
        <>
          {t(getText(), { ...rest })}
          {values.isExportReady ? t('activity_description_Export_annotated_accepted', { ...rest }) : ''}
        </>
      )}
    </span>
  );
};
